/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedContact           : 2024-11-05 12:32:46                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditContact          : 2024-12-11 10:20:44                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * ContactDisplay: customer display component
*/

/* Imports */
import { t } from "i18next";
import { GenericDisplay, GenericDisplayProps } from "../00-generic/GenericDisplay";
/***/

/*
* ContactDisplay: customer display component
* Used to display a customer entity
*/

export interface ContactDisplayProps extends GenericDisplayProps {
  contact: EasyTech.Contact,
  short?: boolean
}

class ContactDisplay extends GenericDisplay<ContactDisplayProps> {
  getLabel = (() => {
    if (!this.props.contact) {
      return t("contact:noData");
    }

    const firstName = this.props.contact.firstName || "";
    const lastName = this.props.short
      ? `${this.props.contact.lastName.substring(0, 1).toUpperCase()}.`
      : (this.props.contact.lastName || "");

    return `${firstName} ${lastName}`.trim();
  });

  getData = (() => {
    return this.props.contact ? (<>
      <span className="block w-full min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">
        {this.props.contact.firstName}
        <span className={`${this.props.variant !== "light" && "text-gray-500"}`}>
          {" "}
          {this.props.short ? `${this.props.contact.lastName.substring(0, 1).toUpperCase()}.` : this.props.contact.lastName}
        </span>
      </span>
    </>) : (
      <>{t("contact:noData")}</>
    );
  });

  getTooltip = (() => this.getLabel());
}

export default ContactDisplay;
/***/
